var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tree',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"areaTree",attrs:{"data":_vm.list,"show-checkbox":"","node-key":"id","default-expanded-keys":_vm.expanded_keys,"default-checked-keys":_vm.checked_keys,"props":_vm.defaultProps},on:{"check":_vm.handleCheck,"node-click":_vm.nodeClick}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f096006c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/order/zujuan/eliteSchoolArea.vue
// module id = 2054
// module chunks = 0